import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { GRAY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import {
  Button,
  IconButton,
  ListItemText,
  MenuItem,
  TextField
} from '@material-ui/core'
import { CloseIcon } from 'asterX-UI/Icons'
import CheckIcon from '@material-ui/icons/Check'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginRight: 'auto'
  },
  btns: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginTop: 20
  },
  round: {
    width: 70,
    height: 70,
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '8px solid' + SUCCESS_COLORS['50'],
    backgroundColor: SUCCESS_COLORS['100'],
    margin: 'auto',
    marginBottom: 20
  },
  successText: {
    fontSize: 14,
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center'
  },
  cross: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))
const CloseRlModal = ({
  workList,
  onClose,
  onSave = () => {},
  isRop = false
}) => {
  const classes = useStyles()
  const isHoldStatus = workList?.saleStatus?.code === 'HOLD'
  const isSubmitDisabled = isRop && !isHoldStatus

  const [isSuccessful, setIsSuccessful] = useState(false)
  const [reason, setReason] = useState(null)
  const [comment, setComment] = useState(null)
  const reasonOptions = [
    'Продажа/выдача авто',
    'Расторжение ДКП - нет ПВ/ не нашли ДС',
    'Расторжение ДКП - не подходят условия БП',
    'Расторжение ДКП - отказ у БП',
    'Расторжение ДКП - не удовлетворительное состояние авто.',
    'Не рассматривает покупку',
    'Купил не в АСТЕР',
    'ДУБЛЬ + УКАЗАТЬ НОМЕР ОСНОВНОГО РЛ , КАК ДОП ПОЛЕ',
    'ОТКАЗ ПО БП (АВТОМАТИЧЕСКАЯ ПРОВЕРКА В КАРФИНЕ НА НАЛИЧИЕ ОДОБА)',
    'ИНТЕРЕСУЮЩЕГО АВТО НЕТ НА СКЛАДЕ',
    'КУПИЛ В АСТЕР В ДРУГОМ ДЦ',
    'КУПИЛ НОВЫЙ АВТО',
    'НИЗКАЯ ОЦЕНКА ПО ТРЕЙД-ИН',
    'НЕ КОРРЕКТНО ВЫДАТ ТАЛОН',
    'НЕ ВЫХОДИТ НА СВЯЗЬ.',
    'ЗАКРЫТ СИСТЕМОЙ/ФЕНИКС'
  ]

  const onSaveReason = () => {
    onSave(`${reason} ${comment}`)
  }

  //TODO: add close reason "Дубль" processing
  const isDouble = false
  return !isSuccessful ? (
    <PageContainerMobile
      customHeader={
        <div className={classes.header}>
          <div className={classes.heading}>Причина закрытия РЛ</div>
          <IconButton
            style={{
              color: GRAY_COLORS[400]
            }}
            onClick={onClose}
            size={'medium'}
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
    >
      <TextField
        label={'Причина'}
        select
        fullWidth
        value={reason}
        onChange={({ target: { value } }) => setReason(value)}
        style={{ marginBottom: 20 }}
      >
        {reasonOptions.map((el, i) => (
          <MenuItem key={i + '_reasonOptions'} value={el}>
            <ListItemText primary={el} />
          </MenuItem>
        ))}
      </TextField>
      {isDouble && (
        <TextField
          label={'Основной РЛ'}
          fullWidth
          style={{ marginBottom: 20 }}
        />
      )}
      <TextField
        label={'Комментарий'}
        value={comment}
        onChange={({ target: { value } }) => setComment(value)}
        multiline
        minRows={5}
        fullWidth
      />
      <div className={classes.btns}>
        <Button
          variant={'contained'}
          color={isRop ? 'secondary' : 'primary'}
          fullWidth
          size={'small'}
          disabled={isSubmitDisabled}
          onClick={() => {
            setIsSuccessful(true)
            onSaveReason()
          }}
        >
          {isRop ? 'Отправить в упущенные' : 'Отправить на согласование'}
        </Button>
        <Button
          variant={'contained'}
          fullWidth
          size={'small'}
          onClick={() => {
            onClose()
          }}
        >
          Отмена
        </Button>
      </div>
    </PageContainerMobile>
  ) : (
    <PageContainerMobile
      customHeader={
        <div className={classes.cross}>
          <IconButton
            style={{
              color: GRAY_COLORS[400],
              fontSize: 24
            }}
            onClick={onClose}
            size={'medium'}
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
    >
      <div className={classes.round}>
        <CheckIcon style={{ fontSize: 24, color: SUCCESS_COLORS['700'] }} />
      </div>
      <div className={classes.successText}>
        {isRop ? 'Закрытие РЛ отправлено на согласование РОП-у' : 'Успешно'}
      </div>
    </PageContainerMobile>
  )
}

export default CloseRlModal
